import { render } from "./UpdateFirmwareModel.vue?vue&type=template&id=f5a2f40a"
import script from "./UpdateFirmwareModel.vue?vue&type=script&lang=js"
export * from "./UpdateFirmwareModel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__